import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';

import FretzHomePage from './app/page';
import ComoFunciona from './ComoFunciona';
import Precos from './Precos';
import RegioesAtendidas from './RegioesAtendidas';
import RegisterDriver from './RegisterDriver';
import EntregadorPortal from './EntregadorPortal';
import EntregadorApp from './EntregadorApp';
import AdminPanel from './AdminPanel';
import PedidoStatus from './PedidoStatus';
import ProcessPayment from './ProcessPayment';
import Sobre from './Sobre';
import ParaEmpresas from './ParaEmpresas';
import Ajuda from './Ajuda';
import Termos from './Termos';
import Privacidade from './Privacidade';
import ContratoIntermediacao from './ContratoIntermediacao';
import Lgpd from './Lgpd';
import Truck from './Truck';
import CookieConsent from './CookieConsent';
import { LeadSignupProvider } from './app/LeadSignupContext';

function App() {
  return (
    <Router>
      <LeadSignupProvider>
        <div className="App">
          <CookieConsent />
          <Routes>
            <Route path="/" element={<FretzHomePage />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/precos" element={<Precos />} />
            <Route path="/regioes-atendidas" element={<RegioesAtendidas />} />
            <Route path="/quero-ser-entregador" element={<RegisterDriver />} />
            <Route path="/entregador/status" element={<EntregadorPortal />} />
            <Route path="/entregador/app" element={<EntregadorApp />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/pedido/:codigo" element={<PedidoStatus />} />
            <Route path="/process_payment" element={<ProcessPayment />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/para-empresas" element={<ParaEmpresas />} />
            <Route path="/ajuda" element={<Ajuda />} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/contrato-entregador" element={<ContratoIntermediacao />} />
            <Route path="/lgpd" element={<Lgpd />} />
            <Route path="/truck" element={<Truck />} />
            {/* fallback */}
            <Route path="*" element={<FretzHomePage />} />
          </Routes>
        </div>
      </LeadSignupProvider>
    </Router>
  );
}

export default App;
